import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'
import 'firebase/messaging'

const config = {
  apiKey: 'AIzaSyBMarqpbP91DBwu3WiJtKORt4dS4ocMOKY',
  authDomain: 'day4thaugland.firebaseapp.com',
  databaseURL: 'https://day4thaugland.firebaseio.com',
  projectId: 'day4thaugland',
  storageBucket: 'day4thaugland.appspot.com',
  messagingSenderId: '706504219973',
}

firebase.initializeApp(config)

const firestore = firebase.firestore()
firestore.enablePersistence()

const functions = firebase.functions()
const storage = firebase.storage()
let firemessage = false
try {
  firemessage = firebase.messaging()
  firemessage.usePublicVapidKey('BI8ytpbbCOlsnHj5mmEw2eav44QjQ2tv5KA5iIN3ufenezCQUrX0_xw5gMevI9g_Mw3HTuQpWA8UbcRnyiOqbz8')
} catch (error) {
  console.warn('Browser not supported', error)
}
const messaging = firemessage
const auth = firebase.auth()
auth.languageCode = 'no'

/**
 *  Uploads a file under a user's directory
 *
 * @param {String} path : Full path and file name of where to store file
 * @param {File} file : A File from an input (eg. e.target.files[0]) or the file api
 * @param {Function} onComplete : Executed when the file uploaded successfully
 * @param {Function} onError : Executed when an error occured
 * @param {Function} onProgress : Executed on progress update, percentage parameter given as argument
 */
function uploadFile (path, file, onComplete, onError, onProgress, meta = {}) {
  const cleanpath = path.replace(/^\/+|\/+$/g, '')
  if (!cleanpath || !file || !onComplete) {
    onError('Invalid execution')
    return
  }
  const storageRef = storage.ref(cleanpath)

  const task = storageRef.put(file, {
    customMetadata: meta,
  })

  task.on(
    'state_changed',
    (snapshot) => { onProgress((snapshot.bytesTransferred / snapshot.totalBytes) * 100) },
    onError,
    () => {
      storageRef.getDownloadURL().then(url => onComplete(url, storageRef.fullPath)).catch(onError)
    },
  )
}

/**
 * Simply returns a unique incremented value each time
 * Within the scope of one session this will always be unique
 *
 * @param {String} prefix (optional): Adds the prefix infront of the nextid
 */
let nextIdCounter = 100
function nextId (prefix) {
  nextIdCounter += 1
  return prefix ? `${prefix}_${nextIdCounter}` : nextIdCounter.toString()
}

/**
 * Returns a filename based on today's date. Use when uploading files to storage
 *
 * @param {String} extenstion : The file's extension to be added to the end of the filename
 */
function getFileName (extenstion) {
  if (!extenstion) throw new Error('Extension arugment required')
  let d = (new Date()).toISOString()
  d = nextId(d.substr(2, 16).replace(/-|:/g, ''))
  return `u${d}.${extenstion}`
}

export { uploadFile, nextId, getFileName, auth, storage, messaging, functions }
export const db = firestore
Vue.prototype.$db = db
export const { GeoPoint, Timestamp, FieldValue } = firebase.firestore
export default firebase

